<template>
    <div>
        <p>Each role includes all of the permissions of the roles above it in addition to what is listed beside it.</p>
        <table>
            <tr>
                <td class="name">User</td>
                <td>Can send/access forms</td>
            </tr>
            <tr>
                <td class="name">Editor</td>
                <td>Can create/edit form templates</td>
            </tr>
            <tr>
                <td class="name">Admin</td>
                <td>Can add/edit/remove users and editors, modify organization settings, and invite teammates</td>
            </tr>
            <tr>
                <td class="name">Owner</td>
                <td>Can add/edit/remove owners and administrators, access/modify billing information, and change organization name</td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'RoleInfo'
    }
</script>

<style lang="scss" scoped>
    p:first-child {
        margin-top: 0;
    }

    table {
        border: none;
        text-align: left;
        border-collapse: collapse;
    }

    td {
        vertical-align: top;
        padding: 0.25em 1em 0.25em 0;
    }

    tr:not(:last-child) {
        border-bottom: 1px solid $color-border;
    }

    .name {
        font-weight: $bold;
    }
</style>